export const calculate = (
  carPrice: number,
  zeroKm: boolean,
  advanced: number,
  interestBank: number,
  interestPrime: number,
  ballon: number,
  payments: number
) => {
  let interest, loanCap;
  if (zeroKm) {
    if (carPrice < 465000) {
      interest = interestPrime + 0.6;
      loanCap = carPrice * 0.85; // the loan can be up to 85% with no max
    } else {
      interest = interestPrime + 0.6;
      loanCap = 400000; // the loan can is up to 400000 when the car price is above 465000
    }
  } else {
    interest = interestBank + interestPrime;
    loanCap = Math.min(carPrice * 0.85, 300000); // the loan can be up to 85% of car price or max 300000
  }
  const monthlyInterest = interest / 100 / 12; // the monthly interest is the annual interest divided by 100 and by 12
  const actualBallon = ballon; // the effective balloon is the min between the balloon and the max balloon

  const adjustedLoan = loanCap - advanced - actualBallon; // subtracting the balloon from the loan amount

  const monthlyPayments = Math.max(
    adjustedLoan *
      (monthlyInterest / (1 - Math.pow(1 + monthlyInterest, -payments))),
    (carPrice - advanced - actualBallon) *
      (monthlyInterest / (1 - Math.pow(1 + monthlyInterest, -payments)))
  );

  const balloonInterestPayment = actualBallon * monthlyInterest;

  return {
    monthlyPayments: monthlyPayments + balloonInterestPayment,
    advancedPayment: advanced,
    totalLoanAmount: loanCap,
    ballonPayment: actualBallon,
    balloonInterestPayment: balloonInterestPayment,
  };
};
